/** Sample process description for tour step 6e (pasted as file content). */
export const SAMPLE_PROCESS_DESCRIPTION_TEXT = `Interviewer (Business Analyst): Thanks for taking the time, Sarah. We are building the new backend for the "EcoCharge" network. Can you walk me through how the physical infrastructure and customer interactions are structured?

Sarah (Operations Manager): Absolutely. At the top level, we have Charging Stations. Each Station is located at a specific physical address and belongs to a geographical Zone, which helps us with maintenance routing.

Interviewer: Got it. And what does a Station actually consist of?

Sarah: A Station has multiple Charging Ports. We need to track the Port ID, its connector type—like CHAdeMO, CCS, or Type 2—and its maximum power output in kilowatts. Ports can be either 'Available', 'In Use', or 'Out of Order'.

Interviewer: How do customers interact with these ports?

Sarah: A Customer registers an account with us, providing their name, email, and payment details. We issue them one or more RFID Cards. When a customer wants to charge their car, they tap their RFID Card on the Port. This initiates a Charging Session.

Interviewer: What data do we need to capture during a Charging Session?

Sarah: The Session needs to record the start time, end time, total energy consumed in kilowatt-hours (kWh), and the total cost. The Session is obviously linked to the specific Port used and the Customer's RFID Card.

Interviewer: How is the total cost calculated? Is it a flat rate?

Sarah: No, it's based on a Tariff. Tariffs are linked to the Zone where the Station is located. A Tariff has a base connection fee and a price per kWh. Sometimes we have peak and off-peak pricing, so the Tariff needs to store those active hours.

Interviewer: Okay, that makes sense. Is there anything else on the operational side?

Sarah: Yes, maintenance. If a Port breaks, our system automatically generates a Maintenance Ticket. A Ticket is assigned an urgency level, a description of the fault, and is linked directly to the specific Port. Technicians will update the ticket status until it's resolved.`

export const SAMPLE_PASTE_FILENAME = 'tour-procesbeschrijving'
